var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"primary","padless":"","app":"","bottom":"","absolute":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"py-4 text-center white--text",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Patrick Weppelmann & Florian Ruf")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }